"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useOfferDetail;
const react_1 = require("react");
const FacebookPixelViewContent_1 = __importDefault(require("@react/common/GtmDataLayer/FacebookPixel/FacebookPixelViewContent"));
const AvailableInquiryOptionsMapper_1 = require("@react/web/SubscriptionOfferDetail/AvailableInquiryOptionsMapper");
const AvailableOffers_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/classes/AvailableOffers"));
const ContractLength_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/classes/ContractLength"));
const MileageYearly_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/classes/MileageYearly"));
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
const StickyPanelPriceOfferView_1 = require("@react/web/SubscriptionOfferDetail/views/StickyPanelPriceOfferView");
const useSubscriptionListing_1 = require("@react/web/Listing/hooks/useSubscriptionListing");
function useOfferDetail() {
    const { carDetailData } = window;
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [contractLengthOptionsData, setContractLengthOptionsData] = (0, react_1.useState)(null);
    const [mileageYearlyOptionsData, setMileageYearlyOptionsData] = (0, react_1.useState)(null);
    const [availableInquiryOptionsData, setAvailableInquiryOptionsData] = (0, react_1.useState)(null);
    const [availableOffers, setAvailableOffers] = (0, react_1.useState)(null);
    const [currentPriceOfferType, setCurrentPriceOfferType] = (0, react_1.useState)(PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE);
    const [currentDisplayedPriceOffer, setCurrentDisplayedPriceOffer] = (0, react_1.useState)(null);
    const usePrevious = (value) => {
        var _a;
        const ref = (0, react_1.useRef)();
        (0, react_1.useEffect)(() => {
            ref.current = value;
        });
        return (_a = ref.current) !== null && _a !== void 0 ? _a : null;
    };
    const prevCurrentDisplayedPriceOffer = usePrevious(currentDisplayedPriceOffer);
    const getSelectedContractLength = (data) => {
        var _a;
        return (_a = data.filter((contractLength) => contractLength.active)[0]) !== null && _a !== void 0 ? _a : null;
    };
    const setContractLengthOptions = (contractLength, fixtermOptions) => {
        const contractLengthOptionsSortedByPrice = fixtermOptions
            .filter((fixterm) => fixterm.active)
            .sort((a, b) => a.monthlyPrice.withoutVat - b.monthlyPrice.withoutVat)
            .map((fixterm, index) => new ContractLength_1.default(contractLength ? (fixterm.contractLength === contractLength) : index === 0, fixterm.contractLength, fixterm.monthlyPrice));
        const selectedContractLength = getSelectedContractLength(contractLengthOptionsSortedByPrice);
        if (selectedContractLength) {
            PageHelper_1.PageHelper.updateSearchParams(PageHelper_1.UrlParameters.CONTRACT_LENGTH, selectedContractLength.value);
        }
        else {
            PageHelper_1.PageHelper.removeSearchParam(PageHelper_1.UrlParameters.CONTRACT_LENGTH);
        }
        const contractLengthOptionsSortedByValue = contractLengthOptionsSortedByPrice.sort((a, b) => a.value - b.value);
        setContractLengthOptionsData(contractLengthOptionsSortedByValue);
    };
    const setMileageYearlyOptions = (mileageYearly, mileageYearlyOptions) => {
        mileageYearlyOptions.forEach((mileage) => {
            mileage.active = mileage.value === mileageYearly;
        });
        PageHelper_1.PageHelper.updateSearchParams(PageHelper_1.UrlParameters.MILEAGE, mileageYearly);
        setMileageYearlyOptionsData(mileageYearlyOptions);
    };
    const setCurrentPriceOfferTypeOption = (offerType) => {
        PageHelper_1.PageHelper.updateSearchParams(PageHelper_1.UrlParameters.INQUIRY_TYPE, offerType);
        setCurrentPriceOfferType(offerType);
    };
    const setAvailableOffersForView = () => {
        var _a, _b, _c;
        if (availableInquiryOptionsData && contractLengthOptionsData) {
            const selectedContractLength = getSelectedContractLength(contractLengthOptionsData);
            const flexibleOffer = (_a = availableInquiryOptionsData.flexible.filter((flex) => flex.active)[0]) !== null && _a !== void 0 ? _a : null;
            const mintermOffer = (_b = availableInquiryOptionsData.minterm.filter((min) => min.active)[0]) !== null && _b !== void 0 ? _b : null;
            const fixtermOffer = (_c = availableInquiryOptionsData.fixterm.filter((fix) => (selectedContractLength === null ? fix.active : (fix.active && fix.contractLength === selectedContractLength.value)))[0]) !== null && _c !== void 0 ? _c : null;
            setAvailableOffers(new AvailableOffers_1.default(fixtermOffer, flexibleOffer, mintermOffer));
        }
    };
    const setAvailableInquiryOptionsByMileageYearly = (mappedAvailableInquiryOptions, mileageYearly) => {
        Object.keys(mappedAvailableInquiryOptions).forEach((key) => {
            mappedAvailableInquiryOptions[key].forEach((offer) => {
                offer.active = offer.mileageYearly === mileageYearly;
            });
        });
        setAvailableInquiryOptionsData(Object.assign({}, mappedAvailableInquiryOptions));
    };
    const setAvailableInquiryOptionsByContractLength = (mappedAvailableInquiryOptions, contractLength) => {
        mappedAvailableInquiryOptions.fixterm.forEach((fixtermOption) => {
            let active = fixtermOption.contractLength === contractLength;
            if (active && currentDisplayedPriceOffer !== null) {
                active = fixtermOption.mileageYearly === currentDisplayedPriceOffer.mileageYearly;
            }
            fixtermOption.active = active;
        });
        setAvailableInquiryOptionsData(Object.assign({}, mappedAvailableInquiryOptions));
    };
    const handleMileageChange = (mileageYearly) => {
        if (mileageYearlyOptionsData && availableInquiryOptionsData) {
            mileageYearlyOptionsData.forEach((item) => {
                item.active = item.value === mileageYearly.value;
            });
            setAvailableInquiryOptionsByMileageYearly(availableInquiryOptionsData, mileageYearly.value);
            setContractLengthOptions(null, availableInquiryOptionsData.fixterm);
            PageHelper_1.PageHelper.updateSearchParams(PageHelper_1.UrlParameters.MILEAGE, mileageYearly.value);
            PageHelper_1.PageHelper.updateLikeButtonPriceOfferId(mileageYearly);
        }
    };
    const handleContractLengthChange = (contractLength) => {
        if (contractLengthOptionsData && availableInquiryOptionsData) {
            contractLengthOptionsData.forEach((item) => {
                item.active = item.value === contractLength.value;
            });
            setAvailableInquiryOptionsByContractLength(availableInquiryOptionsData, contractLength.value);
            setContractLengthOptionsData([...contractLengthOptionsData]);
            PageHelper_1.PageHelper.updateSearchParams(PageHelper_1.UrlParameters.CONTRACT_LENGTH, contractLength.value);
        }
    };
    const handleValueChange = (item) => {
        if (item instanceof MileageYearly_1.default) {
            handleMileageChange(item);
        }
        else {
            handleContractLengthChange(item);
        }
    };
    const handleTabChange = (currentTabName) => {
        setCurrentPriceOfferTypeOption(currentTabName);
    };
    const getSelectedMileageYearlyFromUrl = (mileageYearlyOptions) => {
        const mileageYearlyFromUrl = PageHelper_1.PageHelper.getMileageFromUrl();
        if (mileageYearlyFromUrl === null) {
            return mileageYearlyOptions[0].value;
        }
        const mileageYearlyFromUrlIsAvailable = mileageYearlyOptions.filter((mileage) => mileage.value === Number(mileageYearlyFromUrl)).length === 1;
        return mileageYearlyFromUrlIsAvailable === true ? Number(mileageYearlyFromUrl) : mileageYearlyOptions[0].value;
    };
    const getSelectedContractLengthFromUrl = (mappedFixtermOptions, mileageYearly) => {
        const contractLengthFromUrl = PageHelper_1.PageHelper.getContractLengthFromUrl();
        if (contractLengthFromUrl === null) {
            return null;
        }
        const contractLengthFromUrlIsAvailable = mappedFixtermOptions.filter((fixterm) => fixterm.contractLength === Number(contractLengthFromUrl) && fixterm.mileageYearly === mileageYearly).length === 1;
        return contractLengthFromUrlIsAvailable === true ? Number(contractLengthFromUrl) : null;
    };
    const getSelectedInquiryTypeFromUrl = () => {
        const priceOfferTypeFromUrl = PageHelper_1.PageHelper.getInquiryTypeFromUrl();
        if (useSubscriptionListing_1.isDealFlexibleEnabled === false) {
            return PageHelper_1.InquiryOfferTypesEnum.FIXTERM;
        }
        if (priceOfferTypeFromUrl === null) {
            return PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE;
        }
        const priceOfferTypeFromUrlIsAvailable = Object.values(PageHelper_1.InquiryOfferTypesEnum).includes(priceOfferTypeFromUrl);
        return priceOfferTypeFromUrlIsAvailable === true ? priceOfferTypeFromUrl : PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE;
    };
    const fetchData = () => {
        try {
            const mappedAvailableInquiryOptions = (0, AvailableInquiryOptionsMapper_1.mapAvailableInquiryOptions)(carDetailData.availableForInquiryOptionList);
            const mappedAvailableMileageYearlyOptions = (0, AvailableInquiryOptionsMapper_1.mapAvailableMileageOptions)(carDetailData.availableForInquiryOptionList);
            const priceOfferType = getSelectedInquiryTypeFromUrl();
            const mileageYearly = getSelectedMileageYearlyFromUrl(mappedAvailableMileageYearlyOptions);
            const contractLength = getSelectedContractLengthFromUrl(mappedAvailableInquiryOptions.fixterm, mileageYearly);
            setAvailableInquiryOptionsByMileageYearly(mappedAvailableInquiryOptions, mileageYearly);
            setMileageYearlyOptions(mileageYearly, mappedAvailableMileageYearlyOptions);
            setCurrentPriceOfferTypeOption(priceOfferType);
            setContractLengthOptions(contractLength, mappedAvailableInquiryOptions.fixterm);
            setLoading(false);
        }
        catch (e) {
            console.warn(`Catch useOfferDetail fetchData error | ${e}`);
            setError(e);
            setLoading(false);
        }
    };
    (0, react_1.useEffect)(() => {
        if (currentDisplayedPriceOffer) {
            PageHelper_1.PageHelper.updateComparisonButtonPriceOfferData(currentDisplayedPriceOffer);
            (0, FacebookPixelViewContent_1.default)(currentDisplayedPriceOffer, prevCurrentDisplayedPriceOffer === null);
            (0, StickyPanelPriceOfferView_1.renderStickyPanelPriceOfferView)(currentDisplayedPriceOffer);
        }
    }, [currentDisplayedPriceOffer]);
    (0, react_1.useEffect)(() => {
        fetchData();
    }, []);
    (0, react_1.useEffect)(() => {
        setAvailableOffersForView();
    }, [availableInquiryOptionsData]);
    (0, react_1.useEffect)(() => {
        if (availableOffers) {
            const priceOffer = {
                [PageHelper_1.InquiryOfferTypesEnum.FIXTERM]: availableOffers.fixterm,
                [PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE]: availableOffers.flexible,
                [PageHelper_1.InquiryOfferTypesEnum.MINTERM]: availableOffers.minterm,
            }[currentPriceOfferType];
            if (priceOffer) {
                setCurrentDisplayedPriceOffer(priceOffer);
            }
            else {
                setCurrentDisplayedPriceOffer(availableOffers.flexible);
                setCurrentPriceOfferTypeOption(PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE);
            }
        }
    }, [currentPriceOfferType, availableOffers]);
    return {
        loading,
        error,
        availableOffers,
        mileageYearlyOptionsData,
        contractLengthOptionsData,
        currentDisplayedPriceOffer,
        handleValueChange,
        handleTabChange,
    };
}
